module.exports = __webpack_public_path__ + "static/Visual-Supply-Chain-Network-c9a9a71b49548ab46dd44c45688b83f8.jpg";